/*
 * Copyright, AlpineReplay, Inc. 2021. All rights reserved.
 * Author: Brian Bal
 */
import { Component } from "react"
import { connect } from "react-redux"
import loadUser from "./loadUser"
import loadACL from "./loadAcl"
import loadDivisions from "./loadDivisions"
import loadTeam from "./loadTeam"
import loadGames from "./loadGames"
import loadGame from "./loadGame"
import loadStories from "./loadStories"
import loadEvent from "./loadEvent"
import loadPlayerStats from "./loadPlayerStats"
import loadHeatmap from "./loadHeatmap"
import loadRoster, { loadRosterRelations } from "./loadRoster"
import forceGoodEvent from "./forceGoodEvent"
import loadDivisionStaff from "./loadDivisionStaff"
import loadTeamStaff from "./loadTeamStaff"

const loadUserMapStateToProps = (state, props) => {
    return state
}

const loadUserMapDispatchToProps = (dispatch) => {
    return {
        loadUser: () => {
            dispatch(loadUser())
            dispatch(loadACL())
        },
    }
}

class LoadUserComp extends Component {
    componentDidMount() {
        this.props.loadUser()
    }

    componentDidUpdate() {
        this.props.loadUser()
    }

    render() {
        return null
    }
}

const loadTeamMapStateToProps = (state, props) => {
    return state
}

const loadTeamMapDispatchToProps = (dispatch) => {
    return {
        loadTeam: (teamName) => {
            dispatch(loadTeam(teamName))
        },
    }
}

class LoadTeamComp extends Component {
    componentDidMount() {
        this.props.loadTeam(this.props.match.params.team_name)
    }

    componentDidUpdate() {
        this.props.loadTeam(this.props.match.params.team_name)
    }

    render() {
        return null
    }
}

const loadDivisionsMapStateToProps = (state, props) => {
    return state
}

const loadDivisionsMapDispatchToProps = (dispatch) => {
    return {
        loadDivisions: () => {
            dispatch(loadDivisions())
        },
    }
}

class LoadDivisionsComp extends Component {
    componentDidMount() {
        this.props.loadDivisions()
    }

    componentDidUpdate() {
        this.props.loadDivisions()
    }

    render() {
        return null
    }
}

const loadGamesMapStateToProps = (state, props) => {
    return state
}

const loadGamesMapDispatchToProps = (dispatch) => {
    return {
        loadGames: (teamName) => {
            dispatch(loadGames(teamName))
            dispatch(loadACL())
        },
    }
}

class LoadGamesComp extends Component {
    componentDidMount() {
        this.props.loadGames(this.props.match.params.team_name)
    }

    componentDidUpdate() {
        this.props.loadGames(this.props.match.params.team_name)
    }

    render() {
        return null
    }
}

const loadStoriesMapStateToProps = (state, props) => {
    return state
}

const loadStoriesMapDispatchToProps = (dispatch) => {
    return {
        loadStories: (teamName) => {
            dispatch(loadStories(teamName))
        },
    }
}

class LoadStoriesComp extends Component {
    componentDidMount() {
        this.props.loadStories(this.props.match.params.team_name)
    }

    componentDidUpdate() {
        this.props.loadStories(this.props.match.params.team_name)
    }

    render() {
        return null
    }
}

const loadGameMapStateToProps = (state, props) => {
    return state
}

const loadGameMapDispatchToProps = (dispatch) => {
    return {
        loadGame: (teamName, gameId) => {
            dispatch(loadGame(teamName, gameId))
        },
    }
}

class LoadGameComp extends Component {
    componentDidMount() {
        this.props.loadGame(
            this.props.match.params.team_name,
            this.props.match.params.game_id
        )
    }

    componentDidUpdate() {
        this.props.loadGame(
            this.props.match.params.team_name,
            this.props.match.params.game_id
        )
    }

    render() {
        return null
    }
}

const loadRosterMapStateToProps = (state, props) => {
    return state
}

const loadRosterMapDispatchToProps = (dispatch) => {
    return {
        loadRoster: (teamName, gameId) => {
            dispatch(loadRoster(teamName, gameId))
        },
    }
}

class LoadRosterComp extends Component {
    componentDidMount() {
        let gameId = null
        if (this.props.match.params.game_id) {
            gameId = parseInt(this.props.match.params.game_id, 10)
        }
        this.props.loadRoster(this.props.match.params.team_name, gameId)
    }

    componentDidUpdate() {
        let gameId = null
        if (this.props.match.params.game_id) {
            gameId = parseInt(this.props.match.params.game_id, 10)
        }
        this.props.loadRoster(this.props.match.params.team_name, gameId)
    }

    render() {
        return null
    }
}

const loadRosterRelationMapStateToProps = (state, props) => {
    return state
}

const loadRosterRelationMapDispatchToProps = (dispatch) => {
    return {
        loadRosterRelations: (playerId) => {
            dispatch(loadRosterRelations(playerId))
        },
    }
}

class LoadRosterRelationComp extends Component {
    componentDidMount() {
        this.props.loadRosterRelations(this.props.match.params.player_id)
    }

    componentDidUpdate() {
        this.props.loadRosterRelations(this.props.match.params.player_id)
    }

    render() {
        return null
    }
}

const loadEventMapStateToProps = (state, props) => {
    return state
}

const loadEventMapDispatchToProps = (dispatch) => {
    return {
        loadEvent: (playlistId, eventId, page) => {
            dispatch(loadEvent(playlistId, eventId, page))
        },
    }
}

class LoadEventComp extends Component {
    componentDidMount() {
        this.props.loadEvent(
            this.props.match.params.playlist_id,
            this.props.match.params.event_number,
            this.props.match.params.page
        )
    }

    componentDidUpdate() {
        this.props.loadEvent(
            this.props.match.params.playlist_id,
            this.props.match.params.event_number,
            this.props.match.params.page
        )
    }

    render() {
        return null
    }
}

const loadPlayerStatsMapStateToProps = (state, props) => {
    return state
}

const loadPlayerStatsMapDispatchToProps = (dispatch) => {
    return {
        loadPlayerStats: (gameId) => {
            dispatch(loadPlayerStats(gameId))
        },
    }
}

class LoadPlayerStatsComp extends Component {
    componentDidMount() {
        this.props.loadPlayerStats(this.props.match.params.game_id)
    }

    componentDidUpdate() {
        this.props.loadPlayerStats(this.props.match.params.game_id)
    }

    render() {
        return null
    }
}

const loadDivisionStaffMapStateToProps = (state, props) => {
    return state
}

const loadDivisionStaffMapDispatchToProps = (dispatch) => {
    return {
        loadDivisionStaff: (divisionId) => {
            dispatch(loadDivisionStaff(divisionId))
        },
    }
}

class LoadDivisionStaffComp extends Component {
    componentDidMount() {
        this.props.loadDivisionStaff(this.props.match.params.division_id)
    }

    componentDidUpdate() {
        this.props.loadDivisionStaff(this.props.match.params.division_id)
    }

    render() {
        return null
    }
}

const loadTeamStaffMapStateToProps = (state, props) => {
    return state
}

const loadTeamStaffMapDispatchToProps = (dispatch) => {
    return {
        loadTeamStaff: (teamId) => {
            dispatch(loadTeamStaff(teamId))
        },
    }
}

class LoadTeamStaffComp extends Component {
    componentDidMount() {
        this.props.loadTeamStaff(this.props.match.params.team_id)
    }

    componentDidUpdate() {
        this.props.loadTeamStaff(this.props.match.params.team_id)
    }

    render() {
        return null
    }
}

const forceGoodMapStateToProps = (state, props) => {
    let teamName = props.match.params.team_name
    let gameId = props.match.params.game_id
    let playlistId = props.match.params.playlist_id
    let eventNumber = props.match.params.event_number
    let history = props.history
    let playlistState = {
        selectedCamera: state.selectedCamera,
        sportType: state.sportType,
        selectedHalf: state.selectedHalf,
        selectedInning: state.selectedInning,
        selectedBaseballSide: state.selectedBaseballSide,
        selectedBaseballTag: state.selectedBaseballTag,
        selectedOrder: state.selectedOrder,
    }

    let qa = window.location.hash.includes("/qa/")

    return {
        qa,
        game: state.game.value ? state.game.value : null,
        teamName,
        gameId,
        playlistId,
        eventNumber,
        history,
        playlistState,
        rev: state.rev,
    }
}

const forceGoodMapDispatchToProps = (dispatch) => {
    return {}
}

class ForceGoodEventComp extends Component {
    componentDidMount() {
        if (this.props.qa === false && this.props.game) {
            forceGoodEvent(
                this.props.teamName,
                this.props.gameId,
                this.props.playlistId,
                this.props.eventNumber,
                this.props.game,
                this.props.history,
                this.props.playlistState
            )
        }
    }

    componentDidUpdate() {
        if (this.props.qa === false && this.props.game) {
            forceGoodEvent(
                this.props.teamName,
                this.props.gameId,
                this.props.playlistId,
                this.props.eventNumber,
                this.props.game,
                this.props.history,
                this.props.playlistState
            )
        }
    }

    render() {
        return null
    }
}

const loadHeatmapMapStateToProps = (state, props) => {
    return state
}

const loadHeatmapMapDispatchToProps = (dispatch) => {
    return {
        loadHeatmap: (teamName, gameId, traceNumber) => {
            dispatch(loadHeatmap(teamName, gameId, traceNumber))
        },
    }
}

class LoadHeatmapComp extends Component {
    componentDidMount() {
        this.props.loadHeatmap(
            this.props.match.params.team_name,
            this.props.match.params.game_id,
            this.props.match.params.trace_number
        )
    }

    componentDidUpdate() {
        this.props.loadHeatmap(
            this.props.match.params.team_name,
            this.props.match.params.game_id,
            this.props.match.params.trace_number
        )
    }

    render() {
        return null
    }
}

export const LoadUser = connect(
    loadUserMapStateToProps,
    loadUserMapDispatchToProps
)(LoadUserComp)
export const LoadTeam = connect(
    loadTeamMapStateToProps,
    loadTeamMapDispatchToProps
)(LoadTeamComp)
export const LoadDivisions = connect(
    loadDivisionsMapStateToProps,
    loadDivisionsMapDispatchToProps
)(LoadDivisionsComp)
export const LoadGames = connect(
    loadGamesMapStateToProps,
    loadGamesMapDispatchToProps
)(LoadGamesComp)
export const LoadGame = connect(
    loadGameMapStateToProps,
    loadGameMapDispatchToProps
)(LoadGameComp)
export const LoadStories = connect(
    loadStoriesMapStateToProps,
    loadStoriesMapDispatchToProps
)(LoadStoriesComp)
export const LoadRoster = connect(
    loadRosterMapStateToProps,
    loadRosterMapDispatchToProps
)(LoadRosterComp)
export const LoadRosterRelations = connect(
    loadRosterRelationMapStateToProps,
    loadRosterRelationMapDispatchToProps
)(LoadRosterRelationComp)
export const LoadEvent = connect(
    loadEventMapStateToProps,
    loadEventMapDispatchToProps
)(LoadEventComp)
export const ForceGoodEvent = connect(
    forceGoodMapStateToProps,
    forceGoodMapDispatchToProps
)(ForceGoodEventComp)
export const LoadPlayerStats = connect(
    loadPlayerStatsMapStateToProps,
    loadPlayerStatsMapDispatchToProps
)(LoadPlayerStatsComp)
export const LoadHeatmap = connect(
    loadHeatmapMapStateToProps,
    loadHeatmapMapDispatchToProps
)(LoadHeatmapComp)
export const LoadDivisionStaff = connect(
    loadDivisionStaffMapStateToProps,
    loadDivisionStaffMapDispatchToProps
)(LoadDivisionStaffComp)
export const LoadTeamStaff = connect(
    loadTeamStaffMapStateToProps,
    loadTeamStaffMapDispatchToProps
)(LoadTeamStaffComp)
